var map = {
	"./music-instructions.json": 5296,
	"./music-library-intro2024.json": 5297,
	"./music-library-launch2024.json": 5298,
	"./music-progression.json": 5299,
	"./startSourcesAdvanced.json": 5300,
	"./startSourcesSimple.json": 5301,
	"./startSourcesSimple2.json": 5302,
	"./startSourcesTracks.json": 5303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4902;